import React, { useEffect } from 'react';
import { usePrefersColorScheme } from '../../utils';
import { ThemeProviderContext, useThemeContext } from './ThemeProviderContext';
export function ThemeProvider({ children, theme: initialTheme = 'auto', }) {
    const preferredColorScheme = usePrefersColorScheme();
    const currentTheme = initialTheme === 'auto' ? preferredColorScheme : initialTheme;
    useEffect(() => {
        document.body.dataset.mollieUiTheme = currentTheme;
    }, [currentTheme]);
    return (React.createElement(ThemeProviderContext.Provider, { value: { name: currentTheme } }, children));
}
export function useThemeName() {
    const { name } = useThemeContext();
    return name;
}
//# sourceMappingURL=ThemeProvider.js.map